<template>
  <b-form novalidate @submit.prevent="submit" class="ml-auto mr-auto">
    <p v-if="showError === 'save'">{{ $t('colony.form.error') }}</p>
    <p v-if="showError === 'not found'">{{ $t('colony.form.not_found') }}</p>
    <template v-if="showError !== 'not found'">
      <b-form-group label-for="title">
        <b-form-input :placeholder="$t('colony.form.title.label')" id="title" v-model="form.title" type="text" required :state="$v.form.title.$dirty ? !$v.form.title.$error : null" @blur="$v.form.title.$touch"></b-form-input>
      </b-form-group>
      <b-form-group>
        <b-form-select v-model="form.apiary">
          <option v-for="(apiary) in apiaries" :value="apiary.id" :key="apiary.id">{{ apiary.title }}</option>
        </b-form-select>
      </b-form-group>
      <b-row v-if="loading">
        <b-col class="col-12 mb-3">
          <div class="d-flex justify-content-around flex-row mb-3"><b-spinner></b-spinner></div>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-12 col-md-6 mb-3">
          <b-link class="bg-transparent h-100 text-primary border-primary border form-control text-center" :title="$t('apiary.form.cancel')" @click.prevent="cancel()">
            {{ $t('apiary.form.cancel') }}
          </b-link>
        </b-col>
        <b-col class="col-12 col-md-6 mb-3">
          <b-button class="d-block w-100" type="submit" variant="primary">{{ $t('colony.form.submit') }}</b-button>
        </b-col>
      </b-row>
      <b-row v-if="id">
        <b-col class="col-12 col-md-6"></b-col>
        <b-col class="col-12 col-md-6 mb-3">
          <b-link class="bg-transparent h-100 text-primary border-primary border form-control text-center" :title="$t('unite_colonies_or_remove_queen.unite_colonies')" :to="'/unite-colonies/' + id">
            {{ $t('unite_colonies_or_remove_queen.unite_colonies') }}
          </b-link>
        </b-col>
      </b-row>
      <b-modal :id="'offLineModalColonySave'" centered hide-header-close @ok="hideModal" class="network-modal">
        <template slot="modal-title">
          {{ $t('offLineModal.title') }}
        </template>
        {{ $t('offLineModal.text') }}
        <template slot="modal-footer" class="offline-modal-footer" slot-scope="{ ok }">
          <b-button size="lg" class="mt-3" @click="ok()">
            {{ $t('offLineModal.ok') }}
          </b-button>
        </template>
      </b-modal>
    </template>
  </b-form>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'ColonyForm',
  props: ['id', 'apiary'],
  data () {
    return {
      showError: false,
      loading: false,
      form: {
        title: null,
        apiary: this.apiary
      },
      apiaries: []
    }
  },
  methods: {
    showOffLineModal () {
      this.$bvModal.show('offLineModalColonySave')
    },
    hideModal () {
      this.$bvModal.hide('offLineModalColonySave')
    },
    async submit () {
      if (navigator.onLine) {
        this.$v.form.$touch()
        if (!this.$v.$error) {
          this.loading = true
          let result
          try {
            const token = await this.$api.user.getToken()
            result = await this.$api.colonies.save({ id: this.id, title: this.form.title, apiary: this.form.apiary, token })
            this.loading = false
          } catch (e) { // network error etc.
            if (e.response && e.response.status === 403) {
              this.loading = false
              this.$router.replace('/login')
            }

            result = false
          }

          this.showError = (!result ? 'save' : false)

          if (result) {
            this.$router.replace('/apiary/' + this.form.apiary)
          }
        }
      } else {
        this.showOffLineModal()
      }
    },
    cancel () {
      this.$router.replace('/apiary/' + this.form.apiary)
    },
    clickDelete () {
      this.showModal()
    },
    showModal () {
      this.$bvModal.show('confirm')
    },
    async doDelete () {
      const token = await this.$api.user.getToken()
      const result = await this.$api.colonies.deleteItem({ id: this.id, token })
      this.$router.replace('/colonies')
      return result
    },
    async loadData () {
      try {
        this.apiaries = await this.$api.apiaries.getAll()
      } catch (e) {
        this.showError = 'not found'
        return null
      }

      if (this.id) {
        try {
          const data = await this.$api.colonies.getOne(this.id)
          this.form.title = data.title

          return data
        } catch (e) {
          this.showError = 'not found'
        }
      }

      return null
    }
  },
  validations: {
    form: {
      title: {
        required
      }
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>

<style scoped>
  form {
    max-width: 500px;
    font-family: "Roboto Condensed", sans-serif;
  }
</style>
